import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import { Grid, Typography } from "@material-ui/core";

import './StatCard.scss';

export default class StatCard extends Component {
    render() {
        return (
            <Grid item xs={4}>
                <Paper>
                    <header>
                        <Typography className="text-uppercase">
                            {this.props.title}
                        </Typography>
                    </header>

                    <div className="p-4">
                        <Typography variant="h3" align="center">
                            {this.props.value}
                        </Typography>
                    </div>
                </Paper>
            </Grid>
        )
    }
}
